export default __webpack_public_path__ + "static/media/image5.83341b95.svg";